var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex",class:_vm.getClasses,style:(`width: ${_vm.width}; height: ${_vm.height}; ${_vm.styles}`),attrs:{"title":_vm.title,"tabindex":"1"},on:{"click":function($event){return _vm.$emit('onClick')},"blur":function($event){return _vm.$emit('onBlur')},"focus":function($event){return _vm.$emit('onFocus')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }